import React, { useContext, Fragment, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import SaitDialog from "../atomic/SaitDialog";
import SaitTextField from "../atomic/SaitTextField";
import SaitButton from "../atomic/SaitButton";
import { setGlobalError } from "../store/globalMessageReducer";
import { checkOpen } from "../utils/SaitUtils";
import { Box } from "@mui/material";
import { ModuleContext, saitfecoreNs } from "../utils/Constants";
import { useTranslation } from "react-i18next";

export default function NomeFileExcel(props) {
	const dispatch = useDispatch();
	const module = useContext(ModuleContext);
	const { t } = useTranslation(saitfecoreNs);

	const inputRef = useRef(null);

	const [nome, setNome] = React.useState("File_Export_Excel");

	useEffect(() => {
		if (checkOpen(props.open)) {
			setTimeout(() => {
				inputRef.current.focus();
			}, 0);
		}
	}, [props.open]);

	const onConfirm = async () => {
		if (nome) {
			await props.exportFunction(dispatch, nome, props.exportParams);
			props.close();
			setNome("File_Export_Excel");
		} else {
			dispatch(
				setGlobalError({
					module: module,
					errorMessage: t("error_enter_all_required_fields"),
				}),
			);
		}
	};

	return (
		<SaitDialog
			open={props.open}
			title={t("excel_export")}
			width="xs"
			content={
				<Fragment>
					<SaitTextField inputRef={inputRef} value={nome} onChange={(e) => setNome(e.target.value)} size="large" required label={t("file_name")} />
				</Fragment>
			}
			actions={
				<Fragment>
					<SaitButton text={t("cancel")} color="error" onClick={props.close} />
					<Box sx={{ flexGrow: 1 }} />
					<SaitButton text={t("confirm")} color="success" onClick={onConfirm} />
				</Fragment>
			}
		/>
	);
}
